import { render, staticRenderFns } from "./BaseDialog.vue?vue&type=template&id=3a27d73c&scoped=true&"
import script from "./BaseDialog.vue?vue&type=script&lang=js&"
export * from "./BaseDialog.vue?vue&type=script&lang=js&"
import style0 from "./BaseDialog.vue?vue&type=style&index=0&id=3a27d73c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a27d73c",
  null
  
)

export default component.exports